{
  "version": 1,
  "asset_id": "29b68db9-4dee-4758-b3f5-fb159f7ff1f7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/29b68db9-4dee-4758-b3f5-fb159f7ff1f7/revision-hub-annotated-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/29b68db9-4dee-4758-b3f5-fb159f7ff1f7/revision-hub-annotated-800.webp",
  "original_filename": "revision-hub-annotated-800.webp",
  "size": 41196,
  "content_type": "image/webp",
  "created_at": "2026-10-05T21:16:31Z"
}
